<!--零星计划单池-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="vendorCodeList"
          :focusGet="true"
          :value.sync="queryParams.vendorCodeList"
          selectType="selectMultipleFilter"
          searchParam="vendorCode"
          requestApi="/scp/scpProductionScheduling/supplierBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :dropdown-match-select-width="false"
          sourseField="res"
        />
        <global-select
          slot="statusList"
          :value.sync="queryParams.status"
          :selectData="statusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          ref="itemCodeListRef"
          slot="itemCodeList"
          :value.sync="queryParams.itemCodeList"
          selectType="selectMultipleSearch"
          :dropdown-match-select-width="false"
          requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
          searchParam="itemCode"
          sourseField="res"
          :totalNum="9999999999"
        />
        <global-select
          ref="demandTypeRef"
          slot="demandDeliveryType"
          selectType="selectSearch"
          :value.sync="queryParams.demandDeliveryType"
          requestApi="/scp/scpDemandPlacementBill/demandTypeCombobox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="demandType"
        />
        <global-select
          slot="productBroadCategoryList"
          :value.sync="queryParams.productBroadCategoryList"
          selectType="selectMultipleSearch"
          requestApi="/system/lookup/data/likeList"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'SCP_PRODUCT_BROAD_CATEGORY' }"
          searchParam="lookupValue"
          :dropdown-match-select-width="false"
        />
        <a-select slot="projectTeam" :max-tag-count="1" show-search allowClear option-filter-prop="children" v-model="queryParams.projectTeam" >
          <a-select-option v-for="(item) in projectTeams" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
        </a-select>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiScpDmQuantityPoolExport" ref="download" />
        <a-button type="primary" :loading="loading" @click="handleExport">导出</a-button>
        <a-button type="primary" :loading="loading" @click="handleReview">审核</a-button>
        <a-button :loading="loading" @click="onBatchEdit('orderQuantity')">调整数量</a-button>
        <a-button :loading="loading" @click="onBatchEdit('deliveryDate')">调整交期</a-button>
        <a-button :loading="loading" @click="onBatchEdit('vendorCode')">调整供应商</a-button>
        <batch-edit-modal ref="batchEditModalRef" @finallyUpdate="handleOk" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :selectedRows.sync="selectedRows"
          @selectedRowChange="selectedRowChange"
          :multi-select="true"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
          <template slot="dateFormat" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD') }}</span>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cacheRequest from '@/mixins/cacheRequest'
import { apiScpDmQuantityPoolList, apiScpDmQuantityPoolExport, apiScpDmQuantityPoolAudit } from '@/api/scp/sporadicPlanPool/sporadicPlanPool'
import cloneDeep from 'lodash.clonedeep'
import batchEditModal from '@/views/scp/productionScheduling/sporadicPlanPool/components/batch-edit-modal.vue'

export default {
  name: 'SporadicPlanPool',
  components: { DownloadModal, batchEditModal },
  mixins: [cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      loading: false,
      statusList: [], // 状态列表
      projectTeams: [], // 项目组
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      apiScpDmQuantityPoolExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpDmQuantityPoolList, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        vendorCodeList: undefined,
        itemCodeList: undefined,
        status: undefined,
        demandDeliveryType: undefined,
        productBroadCategoryList: undefined,
        projectTeam: undefined,
        orderNo: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '供应商', decorator: ['vendorCodeList'], type: 'vendorCodeList' },
        { label: '物料编码', decorator: ['itemCodeList'], type: 'itemCodeList' },
        { label: '状态', decorator: ['status'], type: 'statusList' },
        { label: '需求类型', decorator: ['demandDeliveryType'], type: 'demandDeliveryType' },
        { label: '工艺大类', decorator: ['productBroadCategoryList'], type: 'productBroadCategoryList' },
        { label: '项目组', decorator: ['projectTeam'], type: 'projectTeam' },
        { label: '计划单号', decorator: ['orderNo'], type: 'input' }
      ],
      // 表格字段
      columns: [
        { title: '计划单号', dataIndex: 'orderNo', align: 'center', width: 110 },
        { title: '需求类型', dataIndex: 'demandDeliveryTypeName', align: 'center', width: 140 },
        { title: '状态', dataIndex: 'statusName', align: 'center', width: 90 },
        { title: '供应商编码', dataIndex: 'vendorCode', align: 'center', width: 100 },
        { title: '供应商名称', dataIndex: 'supplierNameFull', align: 'center', width: 140 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 120 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 100 },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 160, ellipsis: true },
        { title: '需求数量', dataIndex: 'orderQuantity', align: 'center', width: 90 },
        { title: '需求交期', dataIndex: 'deliveryDate', align: 'center', width: 120, scopedSlots: { customRender: 'dateFormat' } },
        { title: '单位', dataIndex: 'primaryUom', align: 'center', width: 90 },
        { title: '项目组', dataIndex: 'projectTeam', align: 'center', width: 110 },
        { title: '销售类目', dataIndex: 'salesCategory', align: 'center', width: 100 },
        { title: '创建人', dataIndex: 'editDmQuantityName', align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'editDmQuantityTime', align: 'center', width: 140 },
        { title: '审核人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '审核时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        { title: '工艺大类', dataIndex: 'productBroadCategory', align: 'center', width: 100 }
      ]
    }
  },
  created () {
    this.cacheLookupRequest('SCP_PROJECT_TEAM', { lookupType: 'SCP_PROJECT_TEAM', current: 1, pageSize: 999 }, 'projectTeams')
    this.cacheLookupRequest('SCP_DM_QUANTITY_POOL_STATUS', { lookupType: 'SCP_DM_QUANTITY_POOL_STATUS', current: 1, pageSize: 999 }, 'statusList')
  },
  mounted () {
    this.loading = false;
    this.onSearch()
  },
  methods: {
    // 批量修改
    onBatchEdit(field) {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      // 需求数量只能修改一条
      if(field === 'orderQuantity' && this.selectedRows?.length > 1) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      this.$refs.batchEditModalRef.show(field, cloneDeep(this.selectedRowKeys), cloneDeep(this.selectedRows));
    },
    // 审核
    handleReview() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      this.$confirm({
        title: '提示',
        content: '确定提交审核吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          const getNewIdList = this.selectedRows?.filter(obj => obj.status === 'NEW_CREATED').map(obj => obj.id)
          if(getNewIdList?.length < 1) {
            this.$message.success('审核成功')
            return false
          }
          this.loading = true;
          apiScpDmQuantityPoolAudit(getNewIdList).then(res => {
            if (res?.code === 200) {
              this.$message.success('审核成功')
              this.onSearch()
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 表单搜索
    onSearch (value = {}) {
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery () {
      this.queryParams = {
        vendorCodeList: undefined,
        itemCodeList: undefined,
        status: undefined,
        demandDeliveryType: undefined,
        productBroadCategoryList: undefined,
        projectTeam: undefined,
        orderNo: undefined
      }
      this.$refs.itemCodeListRef.handleSearch('');
      if(this.$refs?.demandTypeRef) this.$refs.demandTypeRef.handleSearch('');
    },
    // 导出
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
